// (window.BWMegaMenu = function ($, Behaviors) {
//     "use strict";

//     const module = {};

//     const BWMegaMenu = {
//         adjustHeight: function () {
//             const parents = document.querySelectorAll('.bwMegaMenuHolder');
//             parents.forEach(function (parentEl) {
//                 let items = parentEl.querySelectorAll('ul.sub-menu ul.sub-menu');
//                 let heights = [];
//                 if (window.matchMedia("(max-width: 1240px)").matches) {
//                     parentEl.style.removeProperty('height');
//                 }
//                 items.forEach(function (item) {
//                     if (window.matchMedia("(max-width: 1240px)").matches) {
//                         item.parentElement.style.removeProperty('height');

//                         return;
//                     }
//                     const fixedItemHeight =
//                         parseFloat(getComputedStyle(item).height) +
//                         parseFloat(getComputedStyle(parentEl).paddingTop) +
//                         parseFloat(getComputedStyle(parentEl).paddingBottom);
//                     heights.push(fixedItemHeight);
//                 });

//                 if (window.matchMedia("(max-width: 1240px)").matches) {
//                    return;
//                 }

//                 items.forEach(function (item) {
//                     item.parentElement.style.height = Math.max(...heights) + 'px';
//                 });

//                 parentEl.style.height = Math.max(...heights) + 'px';
//             });
//         },

//         megaMenuBtn: function () {
//             const megaMenuBtn = document.querySelectorAll('[bwmegamenu-btn]');
//             megaMenuBtn.forEach(function (btn) {
//                 btn.addEventListener('click', function (e) {
//                     let target = e.target;
//                     target = $(target);
//                     document.body.classList.toggle('mobile-menu-active');

//                     target.toggleClass('active');
//                     target.next().slideToggle();
//                 });
//             });
//         },

//         hover: function () {
//             const parents = document.querySelectorAll(".bwMegaMenu > li.menu-item-has-children");

//             parents.forEach(parent =>{
//                 const children = parent.querySelectorAll(".bwMegaMenuHelperWrapper > .sub-menu > li");

//                 parent.addEventListener("mouseover", () => {
//                     children[0].classList.add("hover");
//                 });

//                 parent.addEventListener("mouseout", () => {
//                     children[0].classList.remove("hover");
//                 });

//                 children.forEach((child) => {
//                     child.addEventListener("mouseover", (event) => {
//                         event.stopPropagation();
//                         children[0].classList.remove("hover");
//                         child.classList.add("hover");
//                     });

//                     child.addEventListener("mouseout", () => {
//                         child.classList.remove("hover");
//                     });
//                 });
//             });


//         },

//         megaMenuMobile: function () {
//             //1st lvl LIs / Slide toggle
//             const lis = document.querySelectorAll('.bwMegaMenu > li');
//             lis.forEach(function (li) {
//                 li.addEventListener('click', function (e) {
//                     if (window.matchMedia("(min-width: 1241px)").matches) {
//                         return;
//                     }

//                     if (e.target.closest('.bwMegaMenuHolder') || e.target.closest('.sub-menu')) {
//                         return;
//                     }
//                     const target = e.target.closest('li');
//                     target.classList.toggle('active');
//                     $(target).find('.bwMegaMenuHolder ').stop().slideToggle();
//                 });
//             });

//             //2nd lvl LIs / Drawer slide
//             const secondLis = document.querySelectorAll('.bwMegaMenu > li > .bwMegaMenuHolder > .bwMegaMenuHelperWrapper > .sub-menu > li');

//             secondLis.forEach(li => {
//                 li.addEventListener('click', e => {
//                     if (window.matchMedia("(min-width: 1241px)").matches) {
//                         return;
//                     }
//                     if (e.target.matches('.menu-item-text') || e.target.matches('.sub-menu')) {
//                         return;
//                     }
//                     const target = e.target.closest('li');

//                     const ulWrapper = target.querySelector('.ulWrapper');
//                     const bwMenuHolder = target.closest('.bwMenuHolder');
//                     if (ulWrapper) {
//                         ulWrapper.classList.toggle('active');
//                     }

//                     if (bwMenuHolder) {
//                         bwMenuHolder.classList.toggle('active');
//                         bwMenuHolder.scrollTop = 0;
//                     }
//                 });
//             });


//         },

//         createBackBtn: function () {
//             const secondLis = document.querySelectorAll('.bwMegaMenu > li > .bwMegaMenuHolder > .bwMegaMenuHelperWrapper > .sub-menu > li');

//             secondLis.forEach(li => {
//                 //add elements for mobile design
//                 const menuItemWrapper = Array.from(li.childNodes).find(node => node.classList && node.classList.contains('menuItemWrapper'));
//                 if(!menuItemWrapper) return;

//                 const anchorHTML = menuItemWrapper.querySelector('a').querySelector('.menu-item-text').innerHTML;


//                 li.querySelector('.ulWrapper ul.sub-menu')?.insertAdjacentHTML('afterbegin', "<span class='bw-mobile-subtitle'>" + anchorHTML + "</span>");

//                 const backBtn = document.createElement('span');
//                 backBtn.classList.add('menuBackBtn');
//                 backBtn.textContent = 'Back';
//                 li.querySelector('.ulWrapper')?.prepend(backBtn);
//             });

//         },

//         cloneButtons: function () {
//             const header = document.querySelector('header[data-type="header"]');
//             const buttons = header.querySelectorAll('.fl-button');
//             if (buttons.length) {
//                 const buttonsWrapper = document.createElement('DIV');
//                 buttonsWrapper.classList.add('mobileBtnsWrapper');
//                 header.querySelector('.bwMenuHolder').append(buttonsWrapper);
//                 buttons.forEach(button => {
//                     buttonsWrapper.append(button.cloneNode(true));
//                 });

//                 const thirdLvlUls = document.querySelectorAll('.bwMegaMenuHolder li ul.sub-menu');

//                 thirdLvlUls.forEach(ul => {
//                     const buttonsWrapper = document.createElement('DIV');
//                     buttonsWrapper.classList.add('mobileBtnsWrapper');
//                     ul.append(buttonsWrapper);
//                     buttons.forEach(button => {
//                         buttonsWrapper.append(button.cloneNode(true));
//                     });
//                 });
//             }
//         },

//         init: function () {
//             this.megaMenuBtn();
//             this.adjustHeight();
//             this.megaMenuMobile();
//             this.cloneButtons();
//             this.createBackBtn();
//             this.hover();
//         }
//     };

//     // Behaviors.
//     module.bwMegaMenu = BWMegaMenu;

//     let to = true,
//         throttle = function (func, delay) {
//             if (to) {
//                 window.clearTimeout(to);
//             }
//             to = window.setTimeout(func, delay);
//         };

//     window.addEventListener('resize', function () {
//         throttle(function () {
//             BWMegaMenu.adjustHeight();
//         }, 500);
//     });

//     window.addEventListener('DOMContentLoaded', function () {
//         BWMegaMenu.init();
//     });

//     return module;

// }(window.jQuery, window.Behaviors));

console.log('...');